import { render, staticRenderFns } from "./DropzoneImage.vue?vue&type=template&id=74ea9532&scoped=true&"
import script from "./DropzoneImage.vue?vue&type=script&lang=js&"
export * from "./DropzoneImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea9532",
  null
  
)

export default component.exports